import Separator from '@doordash/component-separator'
import { Text, Inset, StackChildren } from '@doordash/design-language'
import * as React from 'react'
import { FAQs } from './constants'
import { FAQLink } from './styles'

import s from './strings'

export const FAQ: React.SFC = () => (
  <StackChildren size={StackChildren.Sizes.Medium}>
    <Separator
      verticalMargin={Separator.Sizes.Small}
      type={Separator.Types.FullBorder}
    />
    <Inset isSquished size={Inset.Sizes.Small}>
      <Text
        display={Text.DisplayModes.Flex}
        textAlign={Text.TextAlignments.left}
        styles={Text.Styles.Bold18}
      >
        {s.faq()}
      </Text>
    </Inset>
    {FAQs.map(({ url, text }) => (
      <StackChildren size={StackChildren.Sizes.Small} key={url}>
        <Inset isSquished size={Inset.Sizes.Small}>
          <FAQLink href={url}>
            <Text
              display={Text.DisplayModes.Flex}
              textAlign={Text.TextAlignments.center}
              styles={Text.Styles.Medium16}
            >
              {text}
            </Text>
          </FAQLink>
        </Inset>
        <Separator
          verticalMargin={Separator.Sizes.Small}
          type={Separator.Types.FullBorder}
        />
      </StackChildren>
    ))}
  </StackChildren>
)

export default FAQ
